import { Helmet } from 'react-helmet-async';
import moneydash from "../feature/moneydash.webp";
import mobilepayments from "../feature/mobilepayments.jpg";
import cash from "../feature/cash.jpg";
import cards from "../feature/cards.jpg";
import FeatureSection from './FeatureSection';
import FeaturesBottom from './FeaturesBottom';
import FeatureHeroSection from './FeatureHeroSection';
import main from "../feature/pymt.webp";
import ContactIcon from './ContactIcon';

function Payments(){

    return (
        <>
            <Helmet>
                <title>Kadhr — Payments That Just Work</title>
                <meta
                    name="description"
                    content="Accept mobile money, cards, bank transfers, and cash — all in one place, fully connected to your orders and customer data."
                />
            </Helmet>

            <main className="mtopcon0 ovrflwhdn" id="up">
                <ContactIcon/>
                <div className="row">
                    <FeatureHeroSection
                        title="Accept payments your customers already use"
                        description="Kadhr lets you accept mobile money, cards, bank transfers, or cash — all in one place, fully linked to your orders."
                        image={main}
                    />
                    <div className="col-12 text-center mt-5 pt-6indx0" id='features'>
                        <FeatureSection title="Mobile Money" description="Accept M-Pesa and other mobile payments seamlessly." image={mobilepayments} reverse />
                        <FeatureSection title="Card Payments" description="Accept local and international cards with ease." image={cards} />
                        <FeatureSection title="Manual Payments" description="Record cash and offline payments without breaking your flow." image={cash} reverse />
                        <FeatureSection title="All Payments in One Place" description="Track every transaction — no matter how the customer pays." image={moneydash} />
                    </div> 
                

                    <FeaturesBottom/>


                </div>
            </main>
        </>
    );
}

export default Payments;
